import axios from 'axios';

/**
 * Shared axios instance for the whole web app.
 *
 * Components pass absolute app paths (e.g. `/api/admin/users`) and no longer
 * need to repeat `withCredentials`. The dev server / nginx proxies `/api` to
 * the backend, so no baseURL is required.
 */
export const api = axios.create({
  withCredentials: true,
});

export function isCanceledRequest(error) {
  return (
    axios.isCancel(error) ||
    error?.name === 'CanceledError' ||
    error?.code === 'ERR_CANCELED'
  );
}

export default api;
